import { render } from "./detailsBody.vue?vue&type=template&id=906e4028"
import script from "./detailsBody.vue?vue&type=script&lang=js"
export * from "./detailsBody.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__